import React, { FC, SyntheticEvent } from 'react';
import { useFormikContext, getIn } from 'formik';
import { Row, Column, FormInput } from 'Shared/components';
import { combineStrings } from 'Shared/utils';
import { FormValuesType } from 'QuoteApp/services/endpoints/GetDetails';
import { ssnNormalizer } from 'QuoteApp/utils';
import styles from './styles.module.css';

type SsnFormPropsType = {
  driverIdsWithSsnErrors: Array<string>;
};

export const SsnForm: FC<SsnFormPropsType> = ({ driverIdsWithSsnErrors }) => {
  const {
    getFieldProps,
    setFieldValue,
    touched,
    errors,
    values,
    isSubmitting,
  } = useFormikContext<FormValuesType>();

  const label = (driverId: string) => {
    const driverName = combineStrings([
      values.drivers[driverId].firstName,
      values.drivers[driverId].middleName,
      values.drivers[driverId].lastName,
      values.drivers[driverId].suffix,
    ]);
    return `SSN: ${driverName}`;
  };

  return (
    <Row className="fs-mask">
      {driverIdsWithSsnErrors.map((driverId, i) => {
        const fieldName = `drivers.${driverId}.ssn`;
        return (
          <Column
            key={fieldName}
            variant="half"
            className={styles.inputWrapper}
          >
            <FormInput
              data-testid={`reports-missing-driver-ssn-input-${i + 1}`}
              {...getFieldProps(fieldName)}
              variant="text"
              label={label(driverId)}
              name={fieldName}
              placeholder="###-##-####"
              value={values.drivers[driverId].ssn}
              disabled={isSubmitting}
              onKeyUp={(event: SyntheticEvent<HTMLInputElement>) => {
                setFieldValue(
                  fieldName,
                  ssnNormalizer(event.currentTarget.value)
                );
              }}
              errorMessage={
                getIn(touched, fieldName) ? getIn(errors, fieldName) : undefined
              }
            />
          </Column>
        );
      })}
    </Row>
  );
};
